module.exports = __webpack_public_path__ + "AvertaStd-ExtraBold.svg?8c4a29c66da1ddaaae0aea05f2cba52c";